const FEATURE_FLAGS = {
  // Keep false while phone booking is temporarily unavailable.
  PHONE_BOOKING_ENABLED: false,
} as const;

export default FEATURE_FLAGS;
